import { SearchResult } from '../services/api';

export type RunScopeId = string | null | undefined;

export const normalizeRunScopeId = (value: RunScopeId): string | null => {
  const trimmed = (value ?? '').trim();
  return trimmed ? trimmed : null;
};

export const getSearchResultRunScopeId = (result: Partial<SearchResult>): string | null => {
  const anyResult = result as any;
  return normalizeRunScopeId(anyResult.run_id || anyResult.source_run_id || anyResult.prompt_run_id);
};

export const shouldPatchSearchResult = (
  result: Partial<SearchResult> | null | undefined,
  segmentId: string,
  runScopeId?: RunScopeId
): boolean => {
  if (!result || (result as any).segment_id !== segmentId) return false;
  if (runScopeId === undefined) return true; // segment-scoped patch (apply to all runs)
  return getSearchResultRunScopeId(result) === normalizeRunScopeId(runScopeId);
};

export const patchSearchResults = (
  results: SearchResult[],
  segmentId: string,
  patch: Partial<SearchResult>,
  runScopeId?: RunScopeId
): SearchResult[] => results.map(r => (shouldPatchSearchResult(r, segmentId, runScopeId) ? { ...r, ...patch } : r));
